import React from "react"
import Template from "../../templates/media"
import { MEDIA } from "../../config"

const Page = props => {
  return <Template {...props} options={MEDIA[9]}></Template>
}

export default Page
